module.exports = "/static/assets/4b8007c6c177d93fbaca7ace4a4f84f8.png";